export enum QbSyncOperation {
  UPSERT = 'UPSERT',
  DELETE = 'DELETE'
}
